module.exports = __webpack_public_path__ + "static/img/learning_resource.40934e7c.png";